import React from 'react';
import { motion } from 'framer-motion';
export const WHATSAPP_NUMBER = '5491153399780';
export const WHATSAPP_MESSAGE = 'Hola, quiero más información sobre el Mega Pack Chi Kung.';
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;
export const WhatsAppIcon = ({
  className = ''
}: {
  className?: string;
}) => <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true" data-id="element-282" data-mp="226hffdvja0zf">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51l-.57-.01c-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884a9.82 9.82 0 016.988 2.898 9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-283" data-mp="1egn3cyj1ggg8" />
  </svg>;
export const WhatsAppFloatingButton = () => <motion.a href={WHATSAPP_URL} target="_blank" rel="noopener noreferrer" aria-label="Escríbenos por WhatsApp" initial={{
  opacity: 0,
  scale: 0.9
}} animate={{
  opacity: 1,
  scale: 1
}} transition={{
  delay: 1.2,
  duration: 0.35,
  ease: 'easeOut'
}} whileHover={{
  scale: 1.04
}} whileTap={{
  scale: 0.96
}} className="fixed bottom-5 right-5 md:bottom-8 md:right-8 z-50 inline-flex items-center gap-2 rounded-sm bg-brand-purpleDark border border-brand-gold/50 px-4 py-3 text-brand-goldLight shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-gold" data-id="element-284" data-mp="3ur4xkldkp4ei">
    <WhatsAppIcon className="w-5 h-5 shrink-0" data-id="element-285" data-mp="nyg2on62chvk" />
    <span className="hidden md:inline font-seal text-[10px] uppercase tracking-seal" data-id="element-286" data-mp="nx502qoctg61">
      Escríbenos
    </span>
  </motion.a>;